import { useParams } from "react-router-dom";
import { useMemo, useCallback } from "react";
import { useGetTagSpectraQuery } from "../tagsSlice";
import useLang from "../../../hooks/useLang";

const useTagSpectraBlock = () => {
  const { tagId } = useParams();
  const lang = useLang();
  const { data: spectraData, isFetching } = useGetTagSpectraQuery(
    { tagId },
    { skip: tagId == null }
  );

  const spectraIds = useMemo(
    () => spectraData?.map((spectrum) => spectrum?.id) ?? [],
    [spectraData]
  );
  const link = useCallback((rowData) => `/spectra/${rowData}`, []);

  const items = useMemo(() => {
    if (isFetching) {
      return [
        {
          id: "loading",
          label: false,
          value: lang("spectra.spectra_loading"),
        },
      ];
    }
    return [
      {
        id: "spectraArray",
        type: "spectraArray",
        data: spectraIds,
        link,
      },
      { id: "notes", formOnly: true },
    ];
  }, [isFetching, spectraIds, link, lang]);

  return items;
};

export default useTagSpectraBlock;
